export const LOGIN = "login"
export const REGISTER = "register"
export const CHECK_AUTH = "checkAuth"
export const LOGOUT = "logout"
export const FORGET_PASSWORD = "forgetPassword"